import { GET_CONFIG, GET_GAMES, GET_CAROUSELS, GET_TOPGAMES, GET_GAME, GET_SERVERS } from "../actions/types";

const initialState = {
  games: [],
  carousels: [],
  topGames: [],
  game: {},
  config: {},
  loading: false
};
const gameReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_CONFIG:
      return {
        ...state,
        config: payload,
        loading: false
      };
    case GET_GAMES:
      return {
        ...state,
        games: payload,
        loading: false
      };
    case GET_CAROUSELS:
      return {
        ...state,
        carousels: payload,
        loading: false
      };
    case GET_TOPGAMES:
      return {
        ...state,
        topGames: payload,
        loading: false
      };
    case GET_GAME:
      return {
        ...state,
        game: payload,
        loading: false
      };
    case GET_SERVERS:
      return {
        ...state,
        game: { ...state.game, servers: payload },
        loading: false
      };

    default:
      return state;
  }
};

export default gameReducer;
